import { useState, useEffect } from "react";
import "../assets/css/loginSignUp.css";
import { useLocation, useNavigate } from "react-router-dom";
import { UsersController } from "../controllers/usersController";
import {
  validateLoginForm,
  validateSignUpForm,
  validateForgotPasswordForm,
} from "../validations/loginSignUpForm";
import { Textbox } from "../components/textbox";
import { useToastPromise } from "../components/toastPromise";
import logo from "../assets/images/logo.png";
import { FeaturesController } from "../controllers/featuresController";
import { ApiUtil } from "../util/apiUtil";
import { Loading } from "../components/loading";
import { Button } from "react-bootstrap";
import { Status } from "../constants/status";

export const LoginSignUp = () => {
  const location = useLocation();
  const toastPromise = useToastPromise();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [isLoginToggle, setIsLoginToggle] = useState(
    location.state?.isLoginToggle ?? true
  );
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const initialLoginInputs = {
    email: "",
    password: "",
  };
  const initialSignUpInputs = {
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
    contactNum: "",
  };
  const initialForgotPassword = { email: "" };
  const [loginInputs, setLoginInputs] = useState(initialLoginInputs);
  const [signUpInputs, setSignUpInputs] = useState(initialSignUpInputs);
  const [forgotPasswordInputs, setForgotPasswordInputs] = useState(
    initialForgotPassword
  );
  const [loginErrors, setLoginErrors] = useState({});
  const [signUpErrors, setSignUpErrors] = useState({});
  const [forgotPasswordErrors, setForgotPasswordErrors] = useState([]);
  const [loginStatus, setLoginStatus] = useState([]);
  const [signUpStatus, setSignUpStatus] = useState([]);
  const [colors] = useState(() => JSON.parse(localStorage.getItem("colors")));
  const handleChange = (event) => {
    saveInputs(event.target.name, event.target.value);
  };
  const saveInputs = (name, value) => {
    isLoginToggle
      ? isForgotPassword
        ? setForgotPasswordInputs((values) => ({ ...values, [name]: value }))
        : setLoginInputs((values) => ({ ...values, [name]: value }))
      : setSignUpInputs((values) => ({ ...values, [name]: value }));
  };
  const resetForm = () => {
    if (isLoginToggle) {
      setLoginInputs(initialLoginInputs);
      setLoginErrors({});
      setForgotPasswordInputs(initialForgotPassword);
      setForgotPasswordErrors({});
    } else {
      setSignUpInputs(initialSignUpInputs);
      setSignUpErrors({});
    }
  };
  const handleLoginSubmit = (event) => {
    event.preventDefault();
    const newErrors = validateLoginForm(loginInputs);
    setLoginErrors(newErrors);
    if (Object.keys(newErrors).length !== 0) {
      console.debug("Form submission failed due to validation loginErrors.");
      return;
    }
    console.debug("Form validated successfully.");
    login();
  };
  const login = () => {
    toastPromise({
      promise: new Promise((resolve, reject) => {
        UsersController.login({
          parameters: loginInputs,
          resolve: resolve,
          reject: reject,
        });
      }),
      successMessage: (data) => `Welcome ${data.email}.`,
      errorMessage: (data) => data,
      finishPromise: () => navigate("/"),
    });
  };
  const handleSignUpSubmit = (event) => {
    event.preventDefault();
    const newErrors = validateSignUpForm(signUpInputs);
    setSignUpErrors(newErrors);
    if (Object.keys(newErrors).length !== 0) {
      console.debug("Form submission failed due to validation errors.");
      return;
    }
    console.debug("Form validated successfully.");
    signUp();
  };
  const signUp = () => {
    toastPromise({
      promise: new Promise((resolve, reject) => {
        UsersController.signUp({
          parameters: signUpInputs,
          resolve: resolve,
          reject: reject,
        });
      }),
      successMessage: (data) => data,
      errorMessage: (data) => data,
      finishPromise: () => {
        setIsLoginToggle(true);
        resetForm();
      },
    });
  };
  const handleForgotPasswordSubmit = (event) => {
    event.preventDefault();
    const newErrors = validateForgotPasswordForm(forgotPasswordInputs);
    setForgotPasswordErrors(newErrors);
    if (Object.keys(newErrors).length !== 0) {
      console.debug("Form submission failed due to validation loginErrors.");
      return;
    }
    console.debug("Form validated successfully.");
    forgotPassword();
  };
  const forgotPassword = () => {
    toastPromise({
      promise: new Promise((resolve, reject) => {
        UsersController.forgotPassword({
          email: forgotPasswordInputs.email,
          resolve: resolve,
          reject: reject,
        });
      }),
      successMessage: (data) => data,
      errorMessage: (data) => data,
      finishPromise: () => {
        setIsLoginToggle(true);
        setIsForgotPassword(false);
        resetForm();
      },
    });
  };
  const getAll = () => {
    getFeatures()
      .then((data) => {
        const features = ApiUtil.deserialize({ data: data });
        setLoginStatus(
          features.filter((data) => data.name === "login")[0]?.status
        );
        setSignUpStatus(
          features.filter((data) => data.name === "signup")[0]?.status
        );
      })
      .catch((error) => console.debug(error))
      .finally(() => setLoading(false));
  };
  const getFeatures = () => {
    return new Promise((resolve, reject) => {
      FeaturesController.getAll({
        resolve: resolve,
        reject: reject,
      });
    });
  };
  const handleToggle = (value) => {
    setIsLoginToggle(value);
    resetForm();
  };
  const handleForgotPasswordToggle = (value) => {
    setIsForgotPassword(value);
    resetForm();
  };
  useEffect(() => {
    getAll();
  }, [colors]);

  return loading ? (
    <Loading />
  ) : (
    <section
      id="loginSignUp"
      style={{
        "--primary-color": colors?.primaryColor || "#ffffff",
        "--secondary-color": colors?.secondaryColor || "#000000",
        "--tertiary-color": colors?.tertiaryColor || "#ffffff",
      }}
    >
      {isForgotPassword ? (
        <Button onClick={() => handleForgotPasswordToggle(false)}>Back</Button>
      ) : (
        <Button onClick={() => navigate("/")}>Back To Home Page</Button>
      )}
      <div className="login-sign-up-container">
        <img className="login-sign-up-image" src={logo} alt="Logo" />
        {isForgotPassword ? (
          <div className="header-container">
            <div className="header selected-header">
              <h3>
                {loginStatus === Status.ACTIVE
                  ? "FORGOT PASSWORD"
                  : loginStatus === Status.COMINGSOON
                  ? Status.getStatusValue(Status.COMINGSOON)
                  : Status.getStatusValue(Status.MAINTENANCE)}
              </h3>
            </div>
          </div>
        ) : (
          <div className="header-container">
            <div
              className={`header ${isLoginToggle ? "selected-header" : ""}`}
              onClick={() => handleToggle(true)}
            >
              <h3>
                {loginStatus === Status.ACTIVE
                  ? "LOGIN"
                  : loginStatus === Status.COMINGSOON
                  ? Status.getStatusValue(Status.COMINGSOON)
                  : Status.getStatusValue(Status.MAINTENANCE)}
              </h3>
            </div>
            <div className="vertical-divider"></div>
            <div
              className={`header ${!isLoginToggle ? "selected-header" : ""}`}
            >
              <h3 onClick={() => handleToggle(false)}>
                {signUpStatus === Status.ACTIVE
                  ? "SIGN UP"
                  : signUpStatus === Status.COMINGSOON
                  ? Status.getStatusValue(Status.COMINGSOON)
                  : Status.getStatusValue(Status.MAINTENANCE)}
              </h3>
            </div>
          </div>
        )}
        <hr />
        {isLoginToggle ? (
          loginStatus === Status.ACTIVE ? (
            isForgotPassword ? (
              <form
                onSubmit={handleForgotPasswordSubmit}
                className="form-container"
              >
                <Textbox
                  type="text"
                  name="email"
                  placeholder="Email Address"
                  value={forgotPasswordInputs.email}
                  onChange={handleChange}
                  errorMsg={forgotPasswordErrors.email}
                />
                <Button onClick={handleForgotPasswordSubmit}>Submit</Button>
              </form>
            ) : (
              <form onSubmit={handleLoginSubmit} className="form-container">
                <Textbox
                  type="text"
                  name="email"
                  placeholder="Email Address"
                  value={loginInputs.email}
                  onChange={handleChange}
                  errorMsg={loginErrors.email}
                />
                <Textbox
                  type="password"
                  name="password"
                  placeholder="Password"
                  value={loginInputs.password}
                  onChange={handleChange}
                  errorMsg={loginErrors.password}
                />
                <label
                  onClick={() => handleForgotPasswordToggle(true)}
                  className="forgot-password-label"
                >
                  Forgot Password
                </label>
                <Button onClick={handleLoginSubmit}>Login</Button>
              </form>
            )
          ) : loginStatus === Status.COMINGSOON ? (
            <div>{Status.getStatusValue(Status.COMINGSOON)}</div>
          ) : (
            <div>{Status.getStatusValue(Status.MAINTENANCE)}</div>
          )
        ) : signUpStatus === Status.ACTIVE ? (
          <form onSubmit={handleSignUpSubmit} className="form-container">
            <Textbox
              type="text"
              name="firstName"
              placeholder="First Name"
              value={signUpInputs.firstName}
              onChange={handleChange}
              errorMsg={signUpErrors.firstName}
            />
            <Textbox
              type="text"
              name="lastName"
              placeholder="Last Name"
              value={signUpInputs.lastName}
              onChange={handleChange}
              errorMsg={signUpErrors.lastName}
            />
            <Textbox
              type="text"
              name="contactNum"
              placeholder="Contact Number "
              value={signUpInputs.contactNum}
              onChange={handleChange}
              errorMsg={signUpErrors.contactNum}
            />
            <Textbox
              type="text"
              name="email"
              placeholder="Email Address"
              value={signUpInputs.email}
              onChange={handleChange}
              errorMsg={signUpErrors.email}
            />
            <Textbox
              type="password"
              name="password"
              placeholder="Password"
              value={signUpInputs.password}
              onChange={handleChange}
              errorMsg={signUpErrors.password}
            />
            <Textbox
              type="password"
              name="confirmPassword"
              placeholder="Confirm Password"
              value={signUpInputs.confirmPassword}
              onChange={handleChange}
              errorMsg={signUpErrors.confirmPassword}
            />
            <Button onClick={handleSignUpSubmit}>Sign Up</Button>
          </form>
        ) : signUpStatus === Status.COMINGSOON ? (
          <div>{Status.getStatusValue(Status.COMINGSOON)}</div>
        ) : (
          <div>{Status.getStatusValue(Status.MAINTENANCE)}</div>
        )}
      </div>
    </section>
  );
};
